export default __webpack_public_path__ + "static/radial-bar-29e36207204877cb93a7ba7fdaf70a5d.png";